export default function ClientError({ error, resetErrorBoundary }: { error: any, resetErrorBoundary: () => void }) {
    console.log(error)
    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    )
}